/**
 * @file searchPublication.saga.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Nov 03, 2025 15:50
 */
import { call, put, takeLeading } from 'redux-saga/effects';
import axiosClient from 'src/services/axiosClient.js';

import {
    DOCUMENT_SEARCH_PUBLICATION_REQUEST,
    documentSearchPublicationSuccess,
    documentSearchPublicationFailure,
} from 'src/store/actions/document/documentDb.actions';

import { dataLoadingSet } from 'src/store/actions/global.actions';
import handleSagaErrors from 'src/store/sagas/handleSagaErrors';

function callApi(payload) {
    const url = '/document/search/publication';

    const baseUrl = import.meta.env.VITE_APP_API_BASE_URL;

    const config = {
        method: 'post',
        baseURL: baseUrl,
        url,
        data: {
            queryObj: payload,
        },
    };

    return new Promise((resolve, reject) => {
        axiosClient(config)
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

function* searchRequestSaga(action) {

    try {
        yield put(dataLoadingSet(true));

        const resp = yield call(callApi, action.payload);
        yield put(documentSearchPublicationSuccess(resp.payload));

    } catch (error) {
        yield put(documentSearchPublicationFailure(error));
        handleSagaErrors(error);
    } finally {
        yield put(dataLoadingSet(false));
    }
}

export default function* searchRequestMonitor() {
    yield takeLeading(DOCUMENT_SEARCH_PUBLICATION_REQUEST, searchRequestSaga);
}
